import React from 'react';
import { Link } from 'react-router-dom';
import GrilleAffaires from './GrilleAffaires';
import useAffaires from './useAffaires';
import { ecrireCriteres } from './criteres';
import { nombre } from './format';

/**
 * Quatre bonnes affaires du moment, avec un lien vers la liste complète.
 *
 * Le fil conducteur des pages qui ne sont pas la vitrine (« Trouvez ma voiture »,
 * compte, favoris, contact…) : où que l'on soit sur le site, ZENKART montre ce qu'il
 * sait faire. Ne rend rien si aucune affaire ne correspond.
 */
export default function BandeauAffaires({ titre = 'Les bonnes affaires du moment', params = {}, taille = 4 }) {
  const { donnees } = useAffaires({ ...params, par_page: taille });
  if (!donnees || !donnees.annonces.length) return null;
  const recherche = ecrireCriteres(params);
  return (
    <section className="zk-bandeau-aff" aria-label={titre}>
      <div className="zk-bandeau-aff-tete">
        <h2>{titre}</h2>
        <Link to={recherche ? `/explore?${recherche}` : '/explore'}>
          Voir les {nombre(donnees.total)} →
        </Link>
      </div>
      <GrilleAffaires donnees={donnees} chargement={false} erreur="" />
    </section>
  );
}
